import { Methods } from '../../api/methods.js';
import type { ParsedArgs } from '../args.js';
import { flag } from '../args.js';
import { CliError, ExitCode } from '../errors.js';
import type { CommandResult } from '../output.js';
import { pickDefined, request, requireConfirmation } from './common.js';

export async function readersCommand(args: ParsedArgs): Promise<CommandResult> {
  const action = args.positionals[1] ?? 'list';
  switch (action) {
    case 'list':
      return request(args, Methods.Readers);
    case 'write': {
      const text = args.positionals[2];
      if (!text) throw new CliError('readers write requires <text>', ExitCode.Usage);
      requireConfirmation(args, 'Writing an NFC tag requires confirmation', 'force');
      return request(
        args,
        Methods.ReadersWrite,
        pickDefined({ text, readerId: flag(args.flags, 'reader') }),
      );
    }
    case 'write-cancel':
      return request(
        args,
        Methods.ReadersWriteCancel,
        pickDefined({ readerId: flag(args.flags, 'reader') }),
      );
    default:
      throw new CliError(`Unknown readers action "${action}"`, ExitCode.Usage);
  }
}
